import api from "./axiosClient";

export const getCatalogRestaurants = async () => (await api.get("/catalog/restaurants")).data;

export const getCatalogCategories = async (restaurantId = "all") => (
    await api.get("/catalog/categories", { params: { restaurantId } })
).data;

export const getCatalogProducts = async (params = {}) => (
    await api.get("/catalog/products", { params })
).data;

export const createCatalogCategories = async (payload) => (
    await api.post("/catalog/categories/batch-create", payload)
).data;

export const updateCatalogCategories = async (payload) => (
    await api.patch("/catalog/categories/batch-update", payload)
).data;

export const createCatalogProducts = async (payload) => (
    await api.post("/catalog/products/batch-create", payload)
).data;

export const updateCatalogProducts = async (payload) => (
    await api.patch("/catalog/products/batch-update", payload)
).data;
